import { Check, Copy } from "lucide-react";
import { useEffect, useState } from "react";

export const CopyIndicator = ({ activeId, thisId }: { activeId: string | null, thisId: string }) => {
    const [isActive, setIsActive] = useState<boolean>(false)

    useEffect((
    ) => {
        let timeout = null;

        setIsActive(false);

        if (activeId && activeId === thisId) {
            setIsActive(true)
            timeout = setTimeout(() => {
                setIsActive(false)
            }, 2000)
        }

        return () => {
            if (timeout) {
                clearTimeout(timeout)
            }
        }
    },
        [activeId])

    return (
        isActive ? <Check className="w-4 h-4" /> : <div className='w-4 h-4 flex items-center justify-center'><Copy className="w-3 h-3" /></div>
    )
}